<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { purchaseApi, settingApi, importApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
   props: {
     templateType: {
       type: String,
       default: 'COMMON',
     },
   },
  data() {
    return {
      dialogVisible: false,
      file: null,
      tableData: [], // 存放上传的excel文件的数据
      tableSku: [], // 存放临时SKU
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      let templatedCode = 'SPUR.PURCHASE_GOODS_IMPORT_AU';
      if (this.templateType === 'COMMON') {
        templatedCode = 'SPUR.PURCHASE_GOODS_IMPORT_CN';
      }
      importApi.getImportTemplateHeaders({
        templateCode: templatedCode,
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, res.content[0].templateFileName);
          });
      });
    },
    importFile(file) {
      this.tableData = [];
      const _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        for (const item of Object.values(outData)) {
          if (item['SKU'] && item['采购数量'] && item['澳币采购价'] && item['售价']) {
          const obj = {
            'skuCode': item['SKU'],
            'alreadyQty': item['采购数量'],
            'auPurchasePrice': item['澳币采购价'],
            'price': item['售价'],
            'linkUrl': item['售价LINK']
          };
          _this.tableData.push(obj);
          _this.tableSku.push(item['SKU']);
          } else {
            _this.msgError(_this.$t('WarehouseManagement.form.msgErrorText'));
            return;
          }
        }
      };
    },
    confirm() {
      if (this.tableSku.length > 0) {
        purchaseApi.purchaseGoodsImport(this.tableSku)
        .then(res => {
          this.tableData = this.$lodash.unionBy(this.tableData, 'skuCode');
          const differentItems = this.$lodash.differenceBy(this.tableData, res, 'skuCode');
          if (differentItems.length > 0) {
            // eslint-disable-next-line no-unused-vars
            let skuCode = '';
            differentItems.forEach(v => {
              skuCode += v.skuCode + ' ';
            });
            this.msgError(`SKU: ${skuCode}在系统中不存在!`);
          } else {
            if (!res.length) return;
            const list = [];
            res.forEach(v1 => {
              this.tableData.forEach(v2 => {
                if (v2.skuCode === v1.skuCode) {
                  list.push({...v2, ...v1});
                }
              });
            });
            this.hide();
            setTimeout(() => {
              this.$emit('submit', list);
            }, 1000);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
